import { SCol, SIcon, SRow } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

import type { OfferFlow, PlanIncludes } from '../../../../../types/offers';

const UnstyledList = styled.ul`list-style-type: none;`;

type Props = {
  planIncludes?: PlanIncludes;
  offerFlow: OfferFlow;
};

const IncludedItemsBreakdown = ({ planIncludes, offerFlow }: Props) =>
  !planIncludes ? null : (
    <SRow>
      <SCol>
        <p className='font-italic smaller-text'>{planIncludes.heading}</p>
        <UnstyledList className='margin-left-md margin-bottom-md'>
          {planIncludes.items.map((item, i) => (
            <li
              key={item}
              className='font-italic smaller-text'
              data-ref={`${offerFlow || ''}-total-plan-includes-${i}`}
            >
              <SIcon name='check' role='img' className='pad-right-xs' />
              {item}
            </li>
          ))}
        </UnstyledList>
      </SCol>
    </SRow>
  );
export default IncludedItemsBreakdown;
